export default __webpack_public_path__ + "static/media/pantry1-afterA-480w.ba840dd4.webp";